var _line, _circle, _circle2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 140,
    viewBox: "0 0 100 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 6,
    x2: 50,
    y2: 43,
    stroke: "black",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 4,
    r: 4,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 90,
    r: 50,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.0001 69.1665C61.5063 69.1665 70.8334 78.4936 70.8334 89.9998C70.8334 101.506 61.5063 110.833 50.0001 110.833C38.4938 110.833 29.1667 101.506 29.1667 89.9998C29.1667 78.4936 38.4938 69.1665 50.0001 69.1665ZM50.0001 73.3332C40.7959 73.3332 33.3334 80.7957 33.3334 89.9998C33.3334 99.204 40.7959 106.667 50.0001 106.667C59.2043 106.667 66.6668 99.204 66.6668 89.9998C66.6668 80.7957 59.2043 73.3332 50.0001 73.3332ZM57.9855 80.2853C58.4792 79.9394 59.1501 79.9978 59.5751 80.4248C60.0001 80.8498 60.0543 81.5207 59.7063 82.0082C55.1647 88.354 52.6647 91.754 52.2105 92.2103C50.9897 93.429 49.0105 93.429 47.7897 92.2103C46.5709 90.9894 46.5709 89.0103 47.7897 87.7894C48.5688 87.0123 51.9668 84.5103 57.9855 80.2853ZM61.4584 87.9165C62.6084 87.9165 63.5418 88.8498 63.5418 89.9998C63.5418 91.1498 62.6084 92.0832 61.4584 92.0832C60.3084 92.0832 59.3751 91.1498 59.3751 89.9998C59.3751 88.8498 60.3084 87.9165 61.4584 87.9165ZM38.5417 87.9165C39.6917 87.9165 40.6251 88.8498 40.6251 89.9998C40.6251 91.1498 39.6917 92.0832 38.5417 92.0832C37.3917 92.0832 36.4584 91.1498 36.4584 89.9998C36.4584 88.8498 37.3917 87.9165 38.5417 87.9165ZM43.3709 80.4248C44.1834 81.2373 44.1834 82.5561 43.3709 83.3707C42.5584 84.1832 41.2376 84.1832 40.4251 83.3707C39.6126 82.5582 39.6126 81.2373 40.4251 80.4248C41.2376 79.6123 42.5563 79.6123 43.3709 80.4248ZM50.0001 76.4582C51.1501 76.4582 52.0834 77.3915 52.0834 78.5415C52.0834 79.6915 51.1501 80.6248 50.0001 80.6248C48.8501 80.6248 47.9167 79.6915 47.9167 78.5415C47.9167 77.3915 48.8501 76.4582 50.0001 76.4582Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.e93fafc0af47250b967ef4db8c31f6d3.svg";
export { ForwardRef as ReactComponent };